<template>
  <div class="atividades-lavadorlancamentosCarro ml-4 mr-4">
    <b-row>
      <b-col cols="1">
        <label for="input-live">Carro</label> 
        <b-form-input 
          id="carro" 
          v-model="lavagem.carro" 
          required 
          @click="reset()" 
          @keyup.enter="loadVeiculo()" 
          placeholder="Nº do carro"
        ></b-form-input>                                              
      </b-col>

      <b-col cols="2">
        <label class="ml-4" for="input-live">Placa</label> 
        <b-input-group-text>
          {{ veiculos.length > 0 ? veiculos.map(at => at.chassi).join(', ') : '-' }}
        </b-input-group-text>
      </b-col>

      <b-col cols="2">
        <label class="ml-4" for="input-live">Modelo Chassi</label> 
        <b-input-group-text>
          {{ veiculos.length > 0 ? veiculos.map(at => at.placa).join(', ') : '-' }}
        </b-input-group-text>
      </b-col>

      <b-col cols="2">
        <label class="ml-4" for="input-live">Denominação</label>   
        <b-input-group-text>
          {{ veiculos.length > 0 ? veiculos.map(at => at.denominacao).join(', ') : '-' }}
        </b-input-group-text>
      </b-col>

      <b-col cols="2">
        <div>                            
          <label for="datepicker-placeholder">Data inicial</label>                        
          <b-form-datepicker 
            id="dt_sol_inicial"  
            required  
            v-model="dt_inicial"  
            placeholder="Data inicial " 
            locale="pt-BR" 
            date-format-options="DD/MM/YYYY"
          ></b-form-datepicker>
        </div>                     
      </b-col>

      <b-col cols="2" class="mb-3">
        <div>                            
          <label for="datepicker-placeholder">Data final</label>
          <b-form-datepicker 
            id="dt_sol_final"  
            required  
            v-model="dt_final" 
            @input="loadLavagensCarro()" 
            placeholder="Data do final" 
            locale="pt-BR" 
            date-format-options="DD/MM/YYYY"
          ></b-form-datepicker> 
        </div>                     
      </b-col>

      <b-col>
                <br>                
                <b-button size="sm" variant="success" class="mr-2 mt-2" block @click="gerarPlanilha()">
                  Planilha
                </b-button>                      
      </b-col>
    </b-row>

    <!-- Tabela de dados -->
    <b-table 
      id="id-lavagens"  
      small 
      hover 
      striped 
      sticky-header="880px"  
      :items="lavagensCarro" 
      :fields="fieldsCarro"
    >    
      <template #cell(tempo_lavagem)="data">
        {{ formatarTempo(data.item.tempo_lavagem) }}
      </template>

 
    </b-table>
  </div>
</template>
<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import * as XLSX from 'xlsx'
import moment from 'moment'
import { mapState } from 'vuex'

export default {    
  name: 'ManutencaoLavadorLancamento',    

  computed: { 
    ...mapState(['user']),
  },

  data() {
    return {            
      mode: 'save',

      empresas: [],
      filiais: [],
      tplavagens: [], // [] lista    
      origens: [], // [] lista    
      tplavagensc: [], // [] lista    

      lavagem: {},
      lavagensCarro: [], // Corrigido para usar 'lavagensCarro'
      veiculos: [],
      dt_inicial: '',
      dt_final: '',  

      valor_empresa: [],
      valor_filial: [],
      value_status: [], // [] lista    
      value_lavagem: [], // [] lista    

      carregando: false,
      atualizando: false,            

      status: {},
      statuss: [], // [] lista            

      fieldsCarro: [
        { key: 'id', label: 'Nº', sortable: true },                 
        { key: 'filial_id', label: 'Filial', sortable: true },                                             
        { key: 'origem', label: 'Origem', sortable: true },              
        { key: 'os_erp', label: 'Nº O.S', sortable: true },             
        { key: 'tipolavagem', label: 'Lavagem', sortable: true },                   
        { key: 'carro', label: 'Carro', sortable: true },                                                                                          
        { key: 'status', label: 'Status', sortable: true },
        { key: 're_encarregado', label: 'Cadastrado por', sortable: true },      
        { key: 're_lavador', label: 'Finalizado por', sortable: true },      
        { key: 'dt_cadastro', label: 'Inicio', sortable: true, formatter: (value, key, lavagensCarro) => {
          return moment(lavagensCarro.dt_cadastro).format('DD/MM/YYYY - HH:mm:ss').replace('Data inválida', '-'); 
        }},
        { key: 'dt_alteracao', label: 'Término', sortable: true, formatter: (value, key, lavagensCarro) => {
          return moment(lavagensCarro.dt_alteracao).format('DD/MM/YYYY - HH:mm:ss').replace('Data inválida', '-'); 
        }},
        { key: 'tempo_lavagem', label: 'Tempo gasto', sortable: true },     
        { key: 'observacao', label: 'Observações', sortable: true },                                           
      ]
    }        
  },

  components: {
    Multiselect
  },

  methods: {
    loadVeiculo() {
      let corpo = {    
        "empresa_id": `${this.user.id_empresa}`,
        "carro": `${this.lavagem.carro}`                 
      };
      const url = `${baseApiUrl}/jb/manutencao/frota/listagem`;
      axios.post(url, corpo)                      
        .then(res => { this.veiculos = res.data; })                      
        .catch(showError);
    },

    gerarPlanilha() {
      // Objeto com os dados para a planilha
      const dados = this.lavagensCarro;
      // Cria uma nova planilha
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(dados);
      // Adiciona a planilha ao workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Dados');
      // Salva o workbook como arquivo
      XLSX.writeFile(workbook, 'LAVADOR.xlsx');
    },

    loadLavagensCarro() {                        
      let corpo = {                  
        "empresa_id": `${this.valor_empresa.map(e => e.id_empresa)}`,    
        "carro_id": this.veiculos.map(at => at.id_carro).join(', ') || null,                          
        "dt_inicial": this.dt_inicial || null,                                            
        "dt_final": this.dt_final || null,                
        "origem": 'webcarro'               
      }; 
      const url = `${baseApiUrl}/sambaiba/lavador/lavagem`;            
      axios.post(url, corpo)
        .then(res => { 
          this.lavagensCarro = res.data; 
          console.log('Dados carregados:', this.lavagensCarro); // Verifique os dados no console
        })        
        .catch(showError);  
    }, 

    formatarTempo(tempo) {
      if (!tempo || typeof tempo !== 'object') {
        return '-';
      }

      const { days = 0, hours = 0, minutes = 0, seconds = 0, milliseconds = 0 } = tempo;

      if (isNaN(days) || isNaN(hours) || isNaN(minutes) || isNaN(seconds) || isNaN(milliseconds)) {
        return '-';
      }

      const formatarComDoisDigitos = (num) => num.toString().padStart(2, '0');
      const milissegundosFormatado = Math.floor(milliseconds).toString().padStart(3, '0');
      const tempoFormatado = `${formatarComDoisDigitos(days)}:${formatarComDoisDigitos(hours)}:${formatarComDoisDigitos(minutes)}:${formatarComDoisDigitos(seconds)}`;

      return tempoFormatado;
    },

    reset() {            
      // Limpe os dados conforme necessário
    }
  },

  mounted() {
    // Qualquer lógica a ser executada após a montagem do componente
  }
}
</script>
